import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

function Email({text}) {

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let timeout = null;
    if(!isReady) {
      timeout = setTimeout(() => {
        setIsReady(1);
      }, 100);
    } else if (isReady) {
      clearTimeout(timeout);
    }
    return () => clearTimeout(timeout);
  });

  if(!isReady) return null;

  return (
    <a href="mailto:ignacioxd@ncsu.edu">{text ? text : "ignacioxd@ncsu.edu"}</a>
  )
}


Email.propTypes = {
  text: PropTypes.string
};

Email.defaultProps = {
};


export default Email;
